import { render, staticRenderFns } from "./AddReader.vue?vue&type=template&id=fbad9df8&"
import script from "./AddReader.vue?vue&type=script&lang=js&"
export * from "./AddReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports